"use strict";

define('view/decision.detail',['require','exports','module','underscore','moment','marionette','config','uikit/uikit','uikit/elements/text','uikit/elements/checkbox','uikit/elements/dropdown','uikit/modules/input.date','uikit/modules/input.counter','./text.editor','./html.viewer','../libs/format/date','templates'],function (require, exports, module) {
  var _ = require('underscore'),
    moment = require('moment'),
    Mn = require('marionette'),
    config = require('config'),
    UIKit = require('uikit/uikit'),
    TextView = require('uikit/elements/text'),
    Checkbox = require('uikit/elements/checkbox'),
    DropdownView = require('uikit/elements/dropdown'),
    DatePicker = require('uikit/modules/input.date'),
    InputCounter = require('uikit/modules/input.counter'),
    TextEditor = require('./text.editor'),
    HTMLViewer = require('./html.viewer'),
    DateFormatter = require('../libs/format/date'),
    Templates = require('templates');
  var DefaultTextEditor = TextEditor.extend({
    options: _.extend({}, TextEditor.prototype.options, config.redactorDefaults, {
      minHeight: null
    })
  });
  var DecisionDetail = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    className: 'ui segment decision-details',
    template: Templates.IRB['decision.detail'],
    options: {
      categories: null,
      boardMembers: null,
      decisionTypes: null,
      settings: null,
      assignments: null,
      policyName: null,
      reviewType: null,
      app: null
    },
    events: {
      'keydown .checkbox input[type="checkbox"]': 'handleCheckboxKeydown'
    },
    update: {
      categories: false,
      boardMembers: false,
      decisionTypes: false,
      settings: false,
      assignments: false,
      app: null
    },
    internalViews: {
      findings: DefaultTextEditor,
      recused: DefaultTextEditor,
      researchersNotes: DefaultTextEditor,
      internalNotes: DefaultTextEditor
    },
    decisionUpdateWarning: null,
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.setupMainView();
    },
    setupMainView: function setupMainView() {
      this.decisionForm.model = this.model;
      this.decisionStatus.text = 'Pending';
      this.decisionStatus.color = 'yellow';
      this.decisionStatus.detail = this.model.get('responsiblePerson').get('displayName');
      this.decisionUpdateWarning = new (TextView.extend({
        tagName: 'h4'
      }))({
        text: "",
        className: 'decision-warning'
      });
      this.decisionUpdateWarning.$el.attr("tabindex", 0);
      this.setupDecisionFields();
      this.setupCategories();
      this.setupFindings();
      this.setupResearchersNotes();
      this.setupInternalNotes();
      if (this.isFullBoardReview()) {
        this.setupVoting();
      }
      this.showModalToUpdateDates();
    },
    showModalToUpdateDates: function showModalToUpdateDates() {
      var self = this;
      var studyAdminCheckInDate = self.model.study.get("adminCheckinDate");
      var decisionAdminCheckInDate = self.model.get("adminCheckinDate");
      var studyExpirationDate = self.model.study.get("expirationDate");
      var decisionExpirationDate = self.model.get("expirationDate");
      var adminCheckInUpdated = self.model.submissionSupportsAdminCheckinDate() && studyAdminCheckInDate !== decisionAdminCheckInDate;
      var expirationDateUpdated = self.model.submissionSupportsExpirationDate() && studyExpirationDate !== decisionExpirationDate;
      if (this.model.isOutdated && (adminCheckInUpdated || expirationDateUpdated)) {
        var modal = this.app.request('modal', {
          approveBtn: {
            text: 'Confirm'
          },
          denyBtn: {
            text: 'Cancel',
            inverted: false
          },
          content: "The Expiration/Admin Check-in date in the study is different than the one on your submission. Would you like to update your submission with the current value from the study?",
          type: 'CONFIRM'
        }, {
          basic: false
        }).on('modal:visible', function () {
          var self = this;
          setTimeout(function () {
            $(self.el).find('.ok').focus();
          }, 800);
        }).on('confirm', function () {
          var studyAdminCheckInDate = self.model.study.attributes.adminCheckinDate;
          var studyExpirationDate = self.model.study.attributes.expirationDate;
          self.updateFormConfiguration({
            expirationDate: {
              value: studyExpirationDate
            },
            adminCheckinDate: {
              value: studyAdminCheckInDate
            }
          });
        });
        modal.$el.css({
          overflow: 'hidden'
        });
      }
    },
    handleCheckboxKeydown: function handleCheckboxKeydown(ev) {
      if ([13, 32].includes(ev.keyCode)) {
        setTimeout(function () {
          $(ev.target).focus();
        }, 10);
      }
    },
    setupDecisionFields: function setupDecisionFields() {
      var decisionTypeOptions = {
          name: 'decisionType',
          bindings: {
            value: 'decisionType'
          },
          clearable: true,
          childBindings: {
            text: 'description'
          },
          collection: this.getOption('decisionTypes'),
          model: this.model,
          placeholder: 'Select a decision'
        },
        resultDateOptions = {
          name: 'resultDate',
          model: this.model,
          todayButton: true,
          bindings: {
            value: 'resultDate'
          }
        },
        adminCheckinDateOptions = {
          name: 'adminCheckinDate',
          model: this.model,
          bindings: {
            value: 'adminCheckinDate'
          }
        },
        expirationDateOptions = {
          name: 'expirationDate',
          model: this.model,
          bindings: {
            value: 'expirationDate'
          }
        };
      if (this.model.useExpirationOrAdminCheckinDate()) {
        var mandateContinuingReviewOptions = {
            name: 'mandateContinuingReview',
            text: 'Continuing review is mandatory.',
            model: this.model,
            bindings: {
              value: 'continuingReviewRequired'
            }
          },
          continuingReviewJustificationTextOptions = {
            name: 'continuingReviewJustificationText',
            text: 'test option text',
            model: this.model,
            bindings: {
              value: 'expirationJustification'
            }
          };
        this.decisionForm.addGroup().addField({
          text: 'Decision'
        }, new DropdownView(decisionTypeOptions)).getOption('parent').addField({
          text: 'Result Date',
          className: 'field decision-modal-field'
        }, new DatePicker(resultDateOptions)).getOption('parent').addField({
          text: 'Administrative Check-In Date',
          className: 'field decision-modal-field'
        }, new DatePicker(adminCheckinDateOptions)).getOption('parent').addGroup({
          autoSize: false
        }).addField(null, new Checkbox(mandateContinuingReviewOptions)).hide().getOption('parent').addField({
          text: 'Expiration Date',
          className: 'field no-pad decision-modal-field'
        }, new DatePicker(expirationDateOptions)).hide().getOption('parent').addField({
          text: 'Justification for expiration.',
          className: 'field no-pad'
        }, new DefaultTextEditor(continuingReviewJustificationTextOptions)).hide().getOption('parent').getOption('parent').getOption('parent').add(this.decisionUpdateWarning);
      } else {
        this.decisionForm.addGroup().addField({
          text: 'Decision'
        }, new DropdownView(decisionTypeOptions)).getOption('parent').addField({
          text: 'Result Date',
          classname: 'field decision-modal-field'
        }, new DatePicker(resultDateOptions)).getOption('parent').addField({
          text: 'Expiration Date',
          classname: 'field decision-modal-field'
        }, new DatePicker(expirationDateOptions)).addField({
          visible: false,
          className: 'field decision-modal-field'
        }, new DatePicker(adminCheckinDateOptions)).getOption('parent').getOption('parent').getOption('parent').addField({}, this.decisionUpdateWarning);
      }
      this.setupDefaultForm();
      this.setupDecisionListeners();
    },
    setupFindings: function setupFindings() {
      this.findings.fluid = true;
      this.findings.model = this.model;
      this.findings.bindings = {
        value: 'findings'
      };
      this.findings.focusOnlyToolbar = true;
    },
    setupResearchersNotes: function setupResearchersNotes() {
      this.researchersNotes.fluid = true;
      this.researchersNotes.model = this.model;
      this.researchersNotes.bindings = {
        value: 'researchNotes'
      };
      this.researchersNotes.focusOnlyToolbar = true;
    },
    setupInternalNotes: function setupInternalNotes() {
      this.internalNotes.fluid = true;
      this.internalNotes.model = this.model;
      this.internalNotes.bindings = {
        value: 'internalNotes'
      };
      this.internalNotes.focusOnlyToolbar = true;
    },
    setupVoting: function setupVoting() {
      var form = this.decisionForm,
        motionedOptions = {
          name: 'motioned',
          childBindings: {
            text: 'displayName',
            disabled: 'conflictOfInterest',
            description: 'conflictOfInterest'
          },
          clearable: true,
          placeholder: 'Select a board member',
          model: this.model,
          bindings: {
            value: 'motioned'
          }
        },
        secondedOptions = {
          name: 'seconded',
          childBindings: {
            text: 'displayName',
            disabled: 'conflictOfInterest',
            description: 'conflictOfInterest'
          },
          disabled: true,
          clearable: true,
          placeholder: 'Select a board member',
          model: this.model,
          bindings: {
            value: 'seconded'
          }
        },
        voteForOptions = {
          name: 'voteFor',
          model: this.model,
          bindings: {
            value: 'voteFor'
          },
          fluid: true
        },
        voteAgainstOptions = {
          name: 'voteAgainst',
          model: this.model,
          bindings: {
            value: 'voteAgainst'
          },
          fluid: true
        },
        voteAbstainOptions = {
          name: 'voteAbstain',
          model: this.model,
          bindings: {
            value: 'voteAbstain'
          },
          fluid: true
        };
      var boardMembers = this.getBoardMembersWithConflicts();
      motionedOptions.collection = boardMembers.clone();
      secondedOptions.collection = boardMembers.clone();
      form.addField({}).getOption('parent').addGroup().addField({
        text: 'Motioned'
      }, new DropdownView(motionedOptions)).getOption('parent').addField({
        text: 'Seconded'
      }, new DropdownView(secondedOptions)).getOption('parent').getOption('parent').addGroup().addField({
        text: 'For'
      }, new InputCounter(voteForOptions)).getOption('parent').addField({
        text: 'Against'
      }, new InputCounter(voteAgainstOptions)).getOption('parent').addField({
        text: 'Abstained'
      }, new InputCounter(voteAbstainOptions));
      this.recused.fluid = true;
      this.recused.model = this.model;
      this.recused.bindings = {
        value: 'recused'
      };
      this.recused.focusOnlyToolbar = true;
      this.setupVotingListeners();
    },
    getBoardMembersWithConflicts: function getBoardMembersWithConflicts() {
      var boardMembers = new Backbone.Collection(this.getOption('boardMembers').pluck('person')),
        assignments = this.getOption('assignments'),
        assignmentService = app.service('assignment'),
        conflicts = assignmentService.getConflictOfInterest(assignments);
      boardMembers.each(function (m) {
        if (_.findWhere(conflicts, {
          id: m.id
        })) {
          m.set('conflictOfInterest', 'Conflict');
        }
      });
      return boardMembers;
    },
    setupDecisionListeners: function setupDecisionListeners() {
      var form = this.decisionForm;
      var templateType = this.model.get('document').get('templateType');
      if (this.model.useExpirationOrAdminCheckinDate() && !this.model.isExempt()) {
        this.listenTo(form.mandateContinuingReview, 'change:value', function (mandateContinuingReviewCheckbox, isChecked) {
          var decision = this.model;
          decision.attributes.continuingReviewRequired = isChecked;
          this.updateFormConfiguration({
            expirationDate: {
              visible: decision.isExpirationDateVisible(),
              required: decision.isExpirationDateVisible()
            },
            continuingReviewJustificationText: {
              visible: decision.isExpirationDateVisible(),
              required: decision.isExpirationDateVisible()
            },
            adminCheckinDate: {
              disabled: false
            }
          });
          this.handleDecisionUpdateWarning();
        });
      }
      this.listenTo(this.model, 'change:decisionType', function (decision, decisionType) {
        this.model.attributes.decisionType = decisionType;
        var decisionSupportsExpiration = decision.decisionSupportsExpirationDate(decisionType),
          resultDateRequired = decision.isResultDateRequired(decisionType),
          decisionSupportsAdminCheckinDate = decision.decisionSupportsAdminCheckinDate(decisionType);
        if (decision.useExpirationOrAdminCheckinDate()) {
          this.updateFormConfiguration({
            resultDate: {
              required: resultDateRequired
            },
            mandateContinuingReview: {
              visible: decisionSupportsExpiration,
              disabled: false
            },
            adminCheckinDate: {
              disabled: false,
              visible: decisionSupportsAdminCheckinDate
            },
            expirationDate: {
              visible: decision.isExpirationDateVisible(),
              required: decision.isExpirationDateVisible()
            },
            continuingReviewJustificationText: {
              visible: decision.isExpirationDateVisible(),
              required: decision.isExpirationDateVisible()
            }
          });
        } else {
          this.updateFormConfiguration({
            resultDate: {
              required: resultDateRequired
            },
            expirationDate: {
              visible: decision.isExpirationDateVisible(decisionType),
              required: decision.isExpirationDateVisible(decisionType) && resultDateRequired
            }
          });
        }
        this.handleDecisionUpdateWarning();
      });
      this.listenTo(this.model, 'change:resultDate', function (decision, resultDate) {
        this.model.attributes.resultDate = resultDate;
        var expirationDateAvailable = this.model.decisionSupportsExpirationDate(),
          expirationDate = this.model.get('expirationDate'),
          templateType = this.model.get('document').get('templateType');
        if (expirationDateAvailable && resultDate && !expirationDate) {
          if (templateType === 'Initial' || templateType === "Renewal") {
            var addDays = this.getOption('settings')._byId['IRB.DEFAULT_STUDY_EXPIRATION_INTERVAL'].get('value') || 365;
            form.expirationDate.value = moment(resultDate).add(addDays, 'days').valueOf();
          }
        }
        this.handleDecisionUpdateWarning();
      });
      this.listenTo(form.expirationDate, 'change:value', function (resultDateView, resultDate) {
        this.model.attributes.expirationDate = resultDate;
        this.handleDecisionUpdateWarning();
      });
      this.listenTo(form.adminCheckinDate, 'change:value', function (resultDateView, resultDate) {
        this.model.attributes.adminCheckinDate = resultDate;
        this.handleDecisionUpdateWarning();
      });
    },
    handleDecisionUpdateWarning: function handleDecisionUpdateWarning() {
      var templateType = this.model.get('document').get('templateType');
      var templateTypeSupportsMessage = templateType === 'Modification' || templateType === 'Renewal';
      var studyAdminCheckInDate = this.model.study.attributes.adminCheckinDate;
      var studyExpirationDate = this.model.study.attributes.expirationDate;
      var adminCheckInDateUpdated = this.model.isAdminCheckInDateUpdated(studyAdminCheckInDate);
      var expirationDateUpdated = this.model.isExpirationDateUpdated(studyExpirationDate);
      var updatedFields = "";
      if (adminCheckInDateUpdated && expirationDateUpdated) {
        updatedFields = "admin check-in date and expiration date";
      } else if (adminCheckInDateUpdated) {
        updatedFields = "admin check-in date";
      } else if (expirationDateUpdated) {
        updatedFields = "expiration date";
      }
      if (templateTypeSupportsMessage && (adminCheckInDateUpdated || expirationDateUpdated)) {
        this.decisionUpdateWarning.text = "Warning: " + updatedFields + " will be updated";
        this.decisionUpdateWarning.visible = true;
      } else {
        this.decisionUpdateWarning.text = "";
        this.decisionUpdateWarning.visible = false;
      }
    },
    setupVotingListeners: function setupVotingListeners() {
      var form = this.decisionForm,
        boardMembers = this.getOption('boardMembers');
      function filteredMembers(value) {
        var filtered = boardMembers.filter(function (m) {
          return m.get('person').get('id') != (value ? value.id : null);
        });
        return _.invoke(filtered, 'get', 'person');
      }
      this.listenTo(form.motioned, 'change:value', function (motionedView, value) {
        if (!value) {
          form.seconded.disabled = true;
          form.seconded.value = null;
        } else {
          form.seconded.disabled = false;
        }
        form.seconded.collection.reset(filteredMembers(value));
      }).listenTo(form.seconded, 'change:value', function (secondedView, value) {
        form.motioned.collection.reset(filteredMembers(value));
      });
    },
    setupCategories: function setupCategories() {
      var categories = this.getOption('categories'),
        categoriesOptions = {
          className: 'grouped padded fields',
          name: 'categories',
          collection: categories || new Backbone.Collection(),
          childBindings: {
            text: 'labeledDescription'
          },
          value: categories ? categories.mapById(this.model.get('categories')) : null
        },
        categoriesView = new HTMLViewer.CheckboxGroup(categoriesOptions);
      this.categoriesForm.add(categoriesView);
      this.listenToOnce(this, 'render', function () {
        this._initialRender = true;
        this.updateCategoriesVisibility();
      }).listenTo(categoriesView, 'change:value', function () {
        var oldCollection = this.model.get('categories');
        oldCollection.reset(categoriesView.value.models);
      }).listenTo(this.model, 'change:decisionType', function (decision, decisionType) {
        this.updateCategories(decisionType);
      });
    },
    updateCategories: function updateCategories(decisionType) {
      var categoriesForm = this.categoriesForm,
        categories = this.getOption('categories'),
        oldQuery = categories._params.get('reviewOrDecisionType'),
        submissionService = app.service('submission'),
        reviewOrDecisionType = submissionService.getReviewOrDecisionTypeForQuery(decisionType, this.model.get('type'));
      if (!this._initialRender || oldQuery == reviewOrDecisionType) {
        return;
      }
      var submission = this.model.get('document');
      var policyName = !!submission ? submission.get('commonRulePolicy') : config.PRE_2018_POLICY;
      categoriesForm.categories.value.reset([]);
      categoriesForm.state = 'loading';
      categories.params({
        reviewOrDecisionType: reviewOrDecisionType,
        policyName: policyName
      }).fetch().promise().bind(this)["finally"](function () {
        this.updateCategoriesVisibility();
        categoriesForm.state = '';
      });
    },
    updateCategoriesVisibility: function updateCategoriesVisibility() {
      var categories = this.getOption('categories'),
        categoriesView = this.categoriesForm;
      if (!categories || !categories.length) {
        if (categories) {
          categoriesView.categories.value.reset([]);
        }
        categoriesView.visible = false;
        categoriesView.$el.prev('.ui.header').hide();
      } else {
        categoriesView.visible = true;
        categoriesView.$el.prev('.ui.header').show();
      }
    },
    updateFormConfiguration: function updateFormConfiguration(options) {
      if (options.mandateContinuingReview && options.mandateContinuingReview.hasOwnProperty('visible') && !options.mandateContinuingReview.visible) {
        options.mandateContinuingReview.value = false;
        options.expirationDate = {
          visible: false
        };
        options.continuingReviewJustificationText = {
          visible: false
        };
      }
      for (var p in options) {
        var formField = this.decisionForm[p],
          formContainer = formField.getOption('parent'),
          option = options[p];
        if (option.hasOwnProperty('visible') && option.visible !== formContainer.visible) {
          option.visible ? formContainer.show() : formContainer.hide();
        }
        option.hasOwnProperty('required') && (formContainer.required = option.required);
        option.hasOwnProperty('disabled') && (formField.disabled = option.disabled);
        option.hasOwnProperty('value') && (formField.value = option.value);
      }
    },
    isFullBoardReview: function isFullBoardReview() {
      var isFullExpeditedAssignment = this.getOption('assignments').getByAssignmentTypeProp('IRB_IS_FULL_EXPEDITED', 'description').models[0],
        isFullExpedited = isFullExpeditedAssignment ? isFullExpeditedAssignment.get('value') == 'true' : false,
        reviewType = this.model.get('type');
      return String(reviewType).toLowerCase() == 'full' && !isFullExpedited;
    },
    isRecusedAvailable: function isRecusedAvailable() {
      return this.isFullBoardReview();
    },
    serializeData: function serializeData() {
      var data = UIKit.ComponentMixin.serializeData.apply(this, arguments);
      data.recusedRequired = this.isRecusedAvailable();
      return data;
    },
    setupDefaultForm: function setupDefaultForm() {
      var decision = this.model;
      if (decision.useExpirationOrAdminCheckinDate()) {
        this.updateFormConfiguration({
          mandateContinuingReview: {
            visible: false
          },
          adminCheckinDate: {
            visible: false
          },
          expirationDate: {
            visible: false
          }
        });
      } else {
        this.updateFormConfiguration({
          expirationDate: {
            visible: false
          }
        });
      }
    }
  });
  var SubDecisionDetail = DecisionDetail.extend({
    internalViews: _.extend({}, DecisionDetail.prototype.internalViews, {
      findings: HTMLViewer,
      researchersNotes: HTMLViewer
    }),
    setupDecisionFields: function setupDecisionFields() {
      var form = this.decisionForm,
        dateFormatter = DateFormatter(config.dateFormat, '--'),
        resultDateOptions = {
          name: 'resultDate',
          model: this.model,
          bindings: {
            text: 'resultDate'
          },
          formatter: dateFormatter
        },
        expirationDateOptions = {
          name: 'expirationDate',
          model: this.model,
          bindings: {
            text: 'expirationDate'
          },
          formatter: dateFormatter
        };
      form.addGroup().addField({}, new (TextView.extend({
        tagName: 'h2'
      }))({
        text: this.model.get('decisionType.description'),
        className: 'ui header'
      })).getOption('parent').getOption('parent').addField({}).getOption('parent').addGroup().addField({
        text: 'Result Date'
      }, new TextView(resultDateOptions)).getOption('parent').addField({
        text: 'Expiration Date',
        visible: this.model.isExpirationDateVisible()
      }, new TextView(expirationDateOptions));
    },
    setupFindings: function setupFindings() {
      this.findings.model = this.model;
      this.findings.bindings = {
        text: 'findings'
      };
    },
    setupResearchersNotes: function setupResearchersNotes() {
      this.researchersNotes.model = this.model;
      this.researchersNotes.bindings = {
        text: 'researchNotes'
      };
    },
    setupCategories: function setupCategories() {
      var categoriesView = this.categoriesForm,
        categories = this.model.get('categories');
      if (categories && categories.length > 0) {
        categoriesView.addField({}, new HTMLViewer.List({
          name: 'categories',
          collection: categories,
          childViewOptions: {
            bindings: {
              text: 'labeledDescription'
            }
          }
        }));
        this.listenToOnce(this, 'render', function () {
          categoriesView.$el.prev('.ui.header').show();
          categoriesView.$el.prev('.ui.header').find('.sub.header').hide();
        });
      }
    },
    showModalToUpdateDates: function showModalToUpdateDates() {
      return;
    },
    onShow: function onShow() {
      this.findings.$el.prev('.ui.header').addClass('dividing').find('.sub.header').hide();
      this.researchersNotes.$el.prev('.ui.header').addClass('dividing').find('.sub.header').hide();
    }
  });
  DecisionDetail.SubDecision = SubDecisionDetail;
  module.exports = DecisionDetail;
});

